import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconVersionChanges({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="M6.52 2.622A.995.995 0 0 1 7 2.5h3.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H7.666L5.938 8.856c-.03.074-.066.143-.11.205A.999.999 0 0 1 5 9.5H1.5A.5.5 0 0 1 1 9V8a.5.5 0 0 1 .5-.5h2.825l1.73-4.36a.996.996 0 0 1 .466-.518zM1 3a.5.5 0 0 1 .5-.5H4a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H1.5A.5.5 0 0 1 1 4V3zm7 4.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h2.5A.5.5 0 0 0 11 9V8a.5.5 0 0 0-.5-.5H8z"/>
        </svg>
    );
}

export default IconVersionChanges;
